import { ApplicationState } from "#store/types";

export class PilotSql2NLService {
    private userId: string;
    private database: string;
    private url: string;

    constructor(state: ApplicationState) {
        this.userId = state.uiState.rid;
        this.database = state.uiState.selectedDatasource.name;
        // this.url = "//pilot.master.inode.iva.igd.fraunhofer.de/api/sql2nl";
        this.url = state.environment.SERVICE_URL + "/api/sql2nl";
        // this.url = state.environment.SERVICE_URL;
        // this.config = new Configuration(baseCfg(state));
        // this.service = new ActionControllerApi(this.config);
        // this.api = new AlternativeNlExplControllerApi(this.config);
    }

    translateSQL(sql: string): Promise<string> {
        // TODO: when sql2nl is exposed via openapi-v2, use that api to fetch.
        return new Promise(async (resolve, reject) => {
            const requestOptions = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-Reference-ID": this.userId,
                },
                body: JSON.stringify({
                    sqlQuery: sql,
                    database: this.database,
                }),
            };
            try {
                const response = await fetch(this.url, requestOptions);
                const data = await response.json();

                if (!response.ok) {
                    return reject();
                }
                let translation = data.payload;
                translation = translation.split("(provided by")[0];
                return resolve(translation);
            } catch (e) {
                return reject(e);
            }
        });
    }
}
